// DataTable.jsx
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "../../components/Sidebar";
import { API_URL } from "../../actions/auth";
import axios from 'axios';


const DataTable = () => {
  // State management
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  // Define columns
  const columns = [
    { key: 'id', label: 'ID', align: '', editable: false },
    { key: 'class', label: 'Class', align: '', editable: false, filterable: true },
    { key: 'name', label: 'Name', align: '', editable: false },
    { key: 'email', label: 'Category', align: '', editable: false, filterable: true },
    { key: 'role', label: 'Amount', align: 'right', editable: false, filterable: false },
  ];

  // Fetch data from API
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {

      setLoading(true);
      // Replace with your actual API endpoint
      const config = {
         headers: {
           Authorization: state.auth.token,
           "Content-Type": "application/json",
         },
      };
      var body = {};
      body["class_id"] = 'Class 1';
      body = JSON.stringify(body);

      // const response = await axios.post(API_URL + "/get_fees_structure_class", body, config)
      const response = await axios.get(API_URL + "/get_fees_structure_all", config)
        console.log(typeof(response))
        console.log(response)

        const transformedData = response.data.fees.map(user => ({
          id: user.id,
          name: user.name,
          email: user.category,
          role: user.amount,
          class: user.class_id,
          status: user.id % 2 === 0 ? 'Active' : 'Inactive'
        }));
      
        setData(transformedData);
        setError(null);

    }catch(e){
      setError('Failed to fetch data');
      console.error('Error fetching data:', e);
    }finally{
      setLoading(false);
    }
  };

  // Get unique values for filters
  const filterOptions = useMemo(() => {
    const options = {};
    columns.forEach(col => {
      if (col.filterable) {
        options[col.key] = [...new Set(data.map(item => item[col.key]))];
      }
    });
    return options;
  }, [data]);

  // Filter and search data
  const filteredData = useMemo(() => {
    let filtered = [...data];

    // Apply search
    if (searchTerm) {
      filtered = filtered.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    // Apply filters
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filtered = filtered.filter(item => item[key] === value);
      }
    });

    return filtered;
  }, [data, searchTerm, filters]);

  // Pagination
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  // Handle edit
  const handleEdit = (item) => {
    setEditingId(item.id);
    setEditFormData({ ...item });
  };

  const handleSaveEdit = async () => {
    try {
      // API call to update (replace with your actual endpoint)
      // await axios.put(`/api/users/${editingId}`, editFormData);
      
      // Update local state
      setData(prevData =>
        prevData.map(item =>
          item.id === editingId ? { ...editFormData } : item
        )
      );
      
      setEditingId(null);
      setEditFormData({});
    } catch (err) {
      console.error('Error updating data:', err);
      alert('Failed to update data');
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditFormData({});
  };

  const handleEditFormChange = (e) => {
    setEditFormData({
      ...editFormData,
      [e.target.name]: e.target.value
    });
  };

  // Handle filters
  const handleFilterChange = (columnKey, value) => {
    setFilters(prev => ({
      ...prev,
      [columnKey]: value
    }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({});
    setSearchTerm('');
    setCurrentPage(1);
  };

  // Loading state
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
        {error}
      </div>
    );
  }
  
  if (!state.auth.isLoading) {
  if (state.auth.isAuthenticated) {

  return (
    <>
      <Sidebar />
    <div className="container mx-auto p-4" style={{marginTop: "75px"}}>
      <div className="bg-white border-sky-100 border-2 shadow-md rounded-lg overflow-hidden">
        {/* Header with search and filters */}
        <div className="p-4 border-b border-gray-200">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            {/* Search */}
            <div className="flex-1">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 hidden"
              />
            </div>

            {/* Filters */}
            <div className="flex flex-wrap gap-2">
              {columns.filter(col => col.filterable).map(col => (
                <select
                  key={col.key}
                  value={filters[col.key] || ''}
                  onChange={(e) => handleFilterChange(col.key, e.target.value)}
                  className="px-3 py-2 border bg-sky-100 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">All {col.label}</option>
                  {filterOptions[col.key]?.map(option => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </select>
              ))}
              
              {(Object.keys(filters).length > 0 || searchTerm) && (
                <button
                  onClick={clearFilters}
                  className="px-3 py-2 text-sm text-gray-600 hover:text-gray-900 border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Clear Filters
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-sky-50">
              <tr>
                {columns.map(col => (
                  <th
                    key={col.key}
                    className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
                  >
                    {col.label}
                  </th>
                ))}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {paginatedData.map((item) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  {columns.map(col => (
                    <td key={col.key} className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" align={col.align}>
                      {editingId === item.id && col.editable ? (
                        <input
                          type="text"
                          name={col.key}
                          value={editFormData[col.key] || ''}
                          onChange={handleEditFormChange}
                          className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      ) : (
                        item[col.key]
                      )}
                    </td>
                  ))}
                  <td className="px-6 py-4 whitespace-nowrap text-sm hidden">
                    {editingId === item.id ? (
                      <div className="flex gap-2">
                        <button
                          onClick={handleSaveEdit}
                          className="text-green-600 hover:text-green-900 font-medium"
                        >
                          Save
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          className="text-gray-600 hover:text-gray-900 font-medium"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => handleEdit(item)}
                        className="text-blue-600 hover:text-blue-900 font-medium"
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* No data message */}
        {paginatedData.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No data found
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-sky-50 px-4 py-3 border-t border-gray-200 flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Showing {((currentPage - 1) * itemsPerPage) + 1} to{' '}
              {Math.min(currentPage * itemsPerPage, filteredData.length)} of{' '}
              {filteredData.length} results
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              
              <div className="flex gap-1">
                {[...Array(totalPages)].map((_, index) => {
                  const pageNum = index + 1;
                  // Show first, last, current, and adjacent pages
                  if (
                    pageNum === 1 ||
                    pageNum === totalPages ||
                    (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                  ) {
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`px-3 py-1 border rounded-md text-sm font-medium ${
                          currentPage === pageNum
                            ? 'bg-blue-600 text-white border-blue-600'
                            : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  } else if (
                    pageNum === currentPage - 2 ||
                    pageNum === currentPage + 2
                  ) {
                    return <span key={pageNum} className="px-2">...</span>;
                  }
                  return null;
                })}
              </div>

              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
    </>
  );
  }else{
      dispatch({ type: "AUTH_ERROR" });
  }
  }else{
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
};

export default DataTable;
